import { request, ResponseData, headersJSON } from "./instance";

export interface WorkMapItem {
  shareId: string;
  shapeId: string;
  likes: number;
  views: number;
  status: 1 | 0;
}

export interface SumbitShareParams {
  type?: "online" | "sync";
  shareId?: string; // 如果存在shareId
  shapeId: string;
  workId: string;
  workName: string; // 在A系列课程中，获取课时名称；在自由创作中，获取作品名称
  panelJson: string; // 选中的元素组成的画板json数据，需要在移动端渲
  config?: {
    shareImage: string;
    shareDescription: string;
    startInput: string[];
    canFork?: boolean;
  };
  tag?: string;
  shareType?: string;
}

export interface ShareItemData {
  shareId: string; // 用这个shareId，拼接上url，组成分享链接
  workId: string;
  shapeId: string;
  workName: string;
  userId: string;
  panelUrl: string;
  likes: number; // 点赞数，默认从0开始
  views: number; // 查看数，默认从1开始
  status: 1 | 0; // 1代表已上线
}

interface OriginalUser {
  userId: string;
  nickname: string;
  birthday: string;
  username: string;
  gender: number;
  avatar: string;
  mobile: string | null;
  cookieKey: string | null;
  cookieValue: string | null;
  role: string | null;
}

interface ShareConfig {
  userAvatar: string;
  shareImage: string;
  nickname: string;
  startInput: string[];
  shareDescription: string;
  version: number;
}

export interface OriginalShare {
  shareId: string;
  shareType: string;
  workId: string;
  userId: string;
  shapeId: string;
  workName: string;
  panelUrl: string;
  likes: number;
  views: number;
  forks: number;
  status: number;
  tag: string;
  config: ShareConfig;
}

interface Own {
  userId: string;
  workId: string;
  belongShareId: string;
  belongUserId: string;
  favorite: boolean;
  workName: string;
  panelUrl: string;
  version: number;
  firstView: boolean;
}

export interface ShareWorkInfo {
  originalUser: OriginalUser;
  originalShare: OriginalShare;
  own?: Own;
  wxCodeImg: string;
}

export interface ShareWorkItem {
  shareId: string;
  workId: string;
  workName: string;
  shapeId: string;
  userId: string;
  nickname: string; // 用户昵称，用来显示 xxx 的《我的时钟探索》
  userAvatar: string; // 用户头像URL
  panelUrl: string;
  wxCodeImg: string; // 微信二维码图片URL
  likes: number; // 点赞数，默认从0开始
  views: number; // 查看数，等同于info接口请求次数，每次请求都会+1，未做防刷处理
  status: 0 | 1; // 状态：0表示作品已下线，1表示作品已上线
  config: ShareConfig;
}

export const fetchWorkMap = async (params: {
  workId: string;
}): Promise<ResponseData<WorkMapItem[]>> => {
  const resp = await request("community/share/work/map", { params });
  return resp;
};

export const fetchShareWorkInfo = async (params: {
  shareId: string;
}): Promise<ResponseData<ShareWorkInfo>> => {
  const resp = await request("community/share/work/info", { params });
  return resp;
};

// 上线
export const postOnlineShareWork = async (
  data: SumbitShareParams
): Promise<ResponseData<ShareItemData>> => {
  const resp = await request("community/share/work/link", {
    method: "POST",
    data,
    headers: headersJSON,
  });
  return resp;
};

export const postDownlineShareWork = async (data: {
  shareId: string;
  action: "unlink" | "delete";
}): Promise<ResponseData<string>> => {
  const resp = await request("community/share/work/action", {
    method: "POST",
    data,
    headers: headersJSON,
  });
  return resp;
};

export const postLikeShareWork = async (data: {
  shareId: string;
  action: "favorite" | "unFavorite";
}): Promise<ResponseData<OriginalShare>> => {
  const resp = await request("community/share/work/own/action", {
    method: "POST",
    data,
    headers: headersJSON,
  });
  return resp;
};

export const postForkShareWork = async (data: {
  shareId: string;
}): Promise<ResponseData<OriginalShare>> => {
  const resp = await request("community/share/work/fork", {
    method: "POST",
    data,
    headers: headersJSON,
  });
  return resp;
};

export const genImage = async (data: {
  workId: string;
  description: string;
  title: string;
}): Promise<ResponseData<string>> => {
  const resp = await request(
    "upload/gen/image",
    {
      method: "POST",
      data,
      headers: headersJSON,
    },
    true
  );
  return resp;
};

export const fetchPublishShareWork = async (): Promise<
  ResponseData<ShareWorkInfo[]>
> => {
  const resp = await request("community/share/work/publish");
  return resp;
};
